module.exports = __webpack_public_path__ + "img/undo.73364f36.svg";